// extracted by mini-css-extract-plugin
export default {"header":"vQu82","headerLeftSide":"_5_DWW","headerRightSide":"_16p8P","avatar":"_3TrML"};